import PropTypes from 'prop-types';
import React from 'react';
import Scene1Svg from '../../../images/vector/lantern-scene-1.svg';
import LanternSprite from '../../../images/vector/lantern-sprite.svg';
import * as IU from '../../animation/interstitialUtils';

export default class ForestAnimationView extends React.Component {
    componentDidMount() {
        this.forestScene().then(() => {
            this.props.onAnimationEnd();
        });
    }

    getViewClassNames() {
        const classes = 'scenery';
        if (this.props.animating) {
            return `${classes} pandown`;
        }
        return classes;
    }

    forestScene() {
        const forestSounndID = IU.forestSound.play();
        IU.addClass(this.innerScene, IU.CAMERA4);
        const peepers = document.getElementById(IU.PEEPERS);
        const scene1Body = document.getElementById(IU.BIRD_BODY);
        const owly = document.querySelector('.scene-inner .owly');
        const actionLayer = document.getElementsByClassName('parallax-layer-14')[0];
        const animationScenes = [
            {
                time: 3000,
                func: () => { IU.hootSound.play(); },
            },
            {
                time: 1000,
                func: () => {
                    IU.addClass(scene1Body, IU.STARTLED);
                },
            },
            {
                time: 1000,
                func: () => {
                    IU.switchClass(this.innerScene, IU.CAMERA4, IU.CAMERA2);
                    IU.hootSound.play();
                },
            },
            {
                time: 2000,
                func: () => {
                    IU.switchClass(this.innerScene, IU.CAMERA2, IU.CAMERA3);
                    IU.addClass(peepers, IU.BLINK);
                    IU.hootSound.play();
                },
            },
            {
                time: 1000,
                func: () => {
                    IU.switchClass(this.innerScene, IU.CAMERA2, IU.CAMERA5);
                },
            },
            {
                time: 500,
                func: () => {
                    IU.removeClass(peepers, IU.BLINK);
                },
            },
            {
                time: 500,
                func: () => { // 10
                    IU.addClass(peepers, IU.BLINK);
                },
            },
            {
                time: 500,
                func: () => {
                    IU.removeClass(peepers, IU.BLINK);
                },
            },
            {
                time: 500,
                func: () => {
                    IU.addClass(peepers, IU.BLINK);
                },
            },
            {
                time: 1000,
                func: () => {
                    IU.addClass(owly, IU.SHOW);
                    IU.removeClass(peepers, IU.BLINK);
                    IU.removeClass(scene1Body, IU.STARTLED);
                },
            },
            {
                time: 2000,
                func: () => {
                    IU.addClass(owly, IU.FALL);
                    IU.waltzSound.play();
                    IU.addClass(actionLayer, 'birddrop');
                    IU.switchClass(this.innerScene,
                        IU.CAMERA5,
                        IU.CAMERA6);
                },
            },
            {
                time: 7000,
                func: () => {
                    IU.magicSound.play();
                },
            },
            {
                time: 3000,
                func: () => {
                    IU.waltzSound.stop();
                    IU.magicSound.stop();
                },
            },
            {
                time: 4500,
                func: () => {
                    IU.forestSound.stop(forestSounndID);
                },
            },
        ];
        return animationScenes.reduce((currentScene, nextScene) => currentScene
            .then(() => IU.callWithDelay(nextScene.func, nextScene.time)), Promise.resolve());
    }

    render() {
        return (
            <div className={this.getViewClassNames()}>
                <div className={`scene-outer ${IU.lowerResolutionAnimation()}`} id="scene-1">
                    <div
                        className="scene-inner camera-0"
                        ref={(innerScene) => { this.innerScene = innerScene; }}>
                        <div className="parallax-layer-0">
                            <div className="bg-upper" />
                            <div className="bg-lower" />
                        </div>
                        <div className="parallax-layer-1">
                            <svg preserveAspectRatio="xMidYMid meet" viewBox="0 0 4600 4600">
                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#scene-1-layer-1" />
                            </svg>
                        </div>
                        <div className="parallax-layer-11">
                            <svg preserveAspectRatio="xMidYMid meet" viewBox="0 0 4600 4600">
                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#scene-1-layer-2" />
                            </svg>
                        </div>
                        <div className="parallax-layer-12">
                            <svg preserveAspectRatio="xMidYMid meet" viewBox="0 0 4600 4600">
                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#scene-1-layer-3" />
                            </svg>
                        </div>
                        <div className="parallax-layer-13">
                            <svg preserveAspectRatio="xMidYMid meet" viewBox="0 0 4600 4600">
                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#scene-1-layer-4" />
                            </svg>
                            <div className="birdie">
                                <svg className="lantern-svg">
                                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#svg-scene-1-birdie" />
                                </svg>
                            </div>
                        </div>
                        <div className="parallax-layer-14">
                            <svg className="svg-long-tree" preserveAspectRatio="xMidYMid meet" viewBox="0 0 4600 9200">
                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#svg-scene-1-tree" />
                            </svg>
                            <div className="peepers blink" />
                            <div className="owly">
                                <svg className="lantern-svg">
                                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#svg-scene-1-owl-strip" />
                                </svg>
                            </div>
                            <svg className="svg-bird-red bush-birds" preserveAspectRatio="xMidYMid meet" viewBox="0 0 300 300">
                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#svg-scene-1-bird-red" />
                            </svg>
                            <svg className="svg-bird-brown bush-birds" preserveAspectRatio="xMidYMid meet" viewBox="0 0 300 300">
                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#svg-scene-1-bird-brown" />
                            </svg>
                            <svg className="svg-bird-yellow bush-birds" preserveAspectRatio="xMidYMid meet" viewBox="0 0 300 300">
                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#svg-scene-1-bird-yellow" />
                            </svg>
                        </div>
                        <div className="parallax-layer-15">
                            <svg preserveAspectRatio="xMidYMid meet" viewBox="0 0 4600 4600">
                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#scene-1-layer-6" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div id="svg-container">
                    <Scene1Svg />
                    <LanternSprite />
                </div>
                {this.props.children}
            </div>
        );
    }
}

ForestAnimationView.propTypes = {
    children: PropTypes.element,
    animating: PropTypes.bool,
    onAnimationEnd: PropTypes.func.isRequired,
};

ForestAnimationView.defaultProps = {
    animating: false,
    children: undefined,
};
